let actions = require("./actions.js");
let utils = require("./utils.js");


let omaha = require("./omaha.js");

let holdem = require("./holdem.js");



function decide() { }




decide.getDecide = function (obj, callback) {
    // console.log(JSON.stringify(obj));
    var typeno = obj.PlayerData.hole_cards.filter((d) => d != "15c" && d != "0");
    // console.log(typeno);
    if (typeno) {
        if (typeno.length == 2) {

            holdem.getDecide(obj, callback);
            return false;

        } else {

            omaha.getDecide(obj, callback);
            return false;


        }
    }
};
decide.GetOdds = function (obj, flop, tbs) {
    // console.log(JSON.stringify(obj));
    var typeno = obj.hole_cards.filter((d) => d != "15c" && d != "0");
    //console.log(typeno);
    if (typeno) {
        if (typeno.length == 2) {
            //console.info("ho");

            return holdem.CreateOdds(obj, flop, obj.username, tbs);


        } else {

            return omaha.CreateOdds(obj, flop, obj.username, tbs);



        }
    }
};
module.exports = decide;
